<script setup>
import { ref,computed } from "vue";
import { fetchGames, fetchProvider } from "../api";
import GameList from "@/casino/components/GameList.vue";
import { useBetStore } from "/store.js";

const props = defineProps({
  slug: {
    type: String,
    required: true,
  },
});
const provider = ref(null);
const games = ref([]);

const pagination = ref({
  page: 1,
  rowsPerPage: 100,
});

const store = useBetStore();

const isMobile = computed(() => {
  return store.getScreenWidth < 512;
});

async function loadGames($state) {
  try {
    const { data } = await fetchGames({
      page: pagination.value.page,
      per_page: pagination.value.rowsPerPage,
      provider_id: provider.value.id,
      device:isMobile.value?'mobile':'desktop'
    });

    games.value.push(...data.data);

    if (data.data.length < pagination.value.rowsPerPage) {
      $state.complete();
    } else {
      $state.loaded();
    }
    pagination.value.page++;
  } catch (error) {
    $state.error();
  }
};

async function updateData() {
  const { data } = await fetchProvider(props.slug);

  provider.value = data.data;
}

updateData();
</script>

<template>
  <article v-if="provider">
    <GameList :name="provider.name" :games="games" @load="loadGames" />
  </article>
</template>

<style scoped>
.casino-view {
  width: 100%;
  min-height: 70vh;
}
</style>
